var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.5v-6.167c0-.466 0-.7.091-.878a.833.833 0 0 1 .364-.364C8.634 10 8.867 10 9.334 10h2.333c.467 0 .7 0 .878.09.157.08.285.208.364.365.091.178.091.412.091.878V17.5M2.167 7.917 9.7 2.267c.287-.216.43-.323.588-.365a.834.834 0 0 1 .425 0c.157.042.3.15.587.365l7.534 5.65m-15-1.25v8.166c0 .934 0 1.4.181 1.757.16.314.415.569.729.728.356.182.823.182 1.756.182h8c.934 0 1.4 0 1.757-.182.314-.16.569-.414.728-.728.182-.357.182-.823.182-1.757V6.667l-5.067-3.8c-.573-.43-.86-.646-1.175-.729a1.667 1.667 0 0 0-.849 0c-.315.083-.602.298-1.176.729l-5.066 3.8z",
    stroke: "#667085",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome03);
export default __webpack_public_path__ + "static/media/home03.ee97c613a0850d9b08baf4a357dc544e.svg";
export { ForwardRef as ReactComponent };